import { useEffect } from "react";
import { BrowserRouter } from "react-router";
import { AuthProvider } from "./core/context/auth";
import { themeChange } from "theme-change";
import { RightSideBarProvider } from "./core/context/rightSideBar";
import DispensaryRoutes from "./modules/routes";
import { Provider } from "react-redux";
import store from "./core/state/store";
import { ThemeContextProvider } from "./core/context/theme";
import { useImpersonationBoot } from "./core/hooks/useImpersonationBoot";
import { SuspensionProvider } from "./core/context/suspension";
import SuspensionGate from "./core/components/OrganizationSuspended/SuspensionGate";
import ThemedToastContainer from "./core/components/ThemedToastContainer";

const App = () => {
    const { isExchanging, exchangeError } = useImpersonationBoot();

    useEffect(() => {
        themeChange(false);
    }, []);

    if (isExchanging) {
        return (
            <div className="flex h-screen items-center justify-center">
                Authenticating as super admin…
            </div>
        );
    }

    if (exchangeError) {
        return (
            <div className="flex h-screen items-center justify-center text-error">
                {exchangeError}
            </div>
        );
    }

    return (
        <Provider store={store}>
            <BrowserRouter>
                <AuthProvider>
                    <ThemeContextProvider>
                        <RightSideBarProvider>
                            <SuspensionProvider>
                                <SuspensionGate>
                                    <DispensaryRoutes />
                                </SuspensionGate>
                            </SuspensionProvider>
                        </RightSideBarProvider>
                        <ThemedToastContainer />
                    </ThemeContextProvider>
                </AuthProvider>
            </BrowserRouter>
        </Provider>
    );
};

export default App;
